import React, { useState, useRef, useEffect, useMemo } from 'react';
import './CustomDropdown.css';

const CustomDropdown = ({ options, value, onChange, placeholder, name }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); //initial value is empty string
  const dropdownRef = useRef(null);

  // Use useMemo to compute filtered options instead of state to prevent infinite loops
  const filteredOptions = useMemo(() => {
    if (searchTerm) {
      return options.filter(option =>
        option.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    return options;
  }, [searchTerm, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange({ target: { name, value: option } });
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSearchTerm('');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div
        className={`custom-dropdown-toggle ${isOpen ? 'open' : ''}`}
        onClick={handleToggle}
      >
        <span className={value ? 'selected-value' : 'placeholder'}>
          {value || placeholder}
        </span>
        <i className={`fas fa-chevron-down ${isOpen ? 'rotate' : ''}`}></i>
      </div>
      {isOpen && (
        <div className="custom-dropdown-menu">
          <div className="custom-dropdown-search">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              autoFocus
              className="search-input"
            />
            <i className="fas fa-search search-icon"></i>
          </div>
          <div className="custom-dropdown-options">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, index) => (
                <div
                  key={index}
                  className={`custom-dropdown-option ${value === option ? 'selected' : ''}`}
                  onClick={() => handleSelect(option)}
                >
                  {option}
                </div>
              ))
            ) : (
              <div className="custom-dropdown-option no-results">
                No results found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;

